module.exports = __webpack_public_path__ + "static/media/portais.07152192.svg";